import { Component } from '@angular/core';
import { CompanyListComponent } from './components/company-list/company-list.component';
import { HeaderComponent } from './components/header/header.component';

@Component({
  selector: 'cognos-home',
  imports: [HeaderComponent, CompanyListComponent],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
export class HomeComponent {
  constructor() {}
}
